import styled from 'styled-components';

export const TablesWrap = styled.div`
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  gap: 3px;
  justify-content: center;

  button {
    flex: 0 0 49%;
    height: 200px;
    border-radius: 15px;
    background-color: #ccc;
  }
`;
